import {
  addFavorite,
  delRecordFavorite,
  delFavorite,
  getCountCart,
  getPointsMemberList
} from "@/api/member/member";

export default {
  namespaced: true,
  state: {
    list: []
  },
  actions: {
    // 添加收藏
    async addFavorite(context, params) {
      console.log(params);
      const res = await addFavorite(params);
      return res;
    },

    // 取消收藏
    async delFavorite(context, params) {
      console.log(params);
      const res = await delFavorite(params);
      return res;
    },

    // 取消收藏
    async delRecordFavorite(context, params) {
      const res = await delRecordFavorite(params);
      return res;
    },
    async getCountCart(context, params) {
      const data = await getCountCart(params);
      return data;
    },
    async getPointsMemberList(context, params) {
      const { data } = await getPointsMemberList(params);
      return data;
    }

  }
};
